import React from 'react';
import _ from 'lodash';
import moment from 'moment';

const cc = require('cryptocompare');

// TEMPORARY LOCAL TEST ONLY
cc.setApiKey('c8179a0f2efadc16a2b8a00e8af3300eddd7a06203f448e4fd579de018fbfe68');

export const AppContext = React.createContext();

const MAX_FAVORITES = 10;
const TIME_UNITS = 10;

export class AppProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 'dashboard',
      favorites: ['BTC', 'ETH', 'XMR', 'DOGE'],
      timeInterval: 'months',
      ...this.savedSettings(),
      setPage: this.setPage,
      addCoin: this.addCoin,
      removeCoin: this.removeCoin,
      isInFavorites: this.isInFavorites,
      confirmFavorites: this.confirmFavorites,
      setCurrentFavorite: this.setCurrentFavorite,
      setFilteredCoins: this.setFilteredCoins,
      changeChartSelect: this.changeChartSelect
    };
  }

  componentDidMount = () => {
    this.fetchCoins();
    this.fetchPrices();
    this.fetchHistorical();
  };

  fetchCoins = async () => {
    try {
      const response = await cc.coinList();

      console.log('coin response:', response);

      const coinList = response.Data || response;

      this.setState({ coinList });
    } catch (error) {
      console.error('Coin list error:', error);
    }
  };

  fetchPrices = async () => {
    if (this.state.firstVisit) return;

    let prices = await this.prices();

    prices = prices.filter(
      price => price && Object.keys(price).length
    );

    this.setState({ prices });
  };

  fetchHistorical = async () => {
    if (this.state.firstVisit) return;

    try {
      const results = await this.historical();

      const historical = [
        {
          name: this.state.currentFavorite,
          data: results.map((ticker, index) => [
            moment()
              .subtract({
                [this.state.timeInterval]: TIME_UNITS - index
              })
              .valueOf(),

            ticker.USD
          ])
        }
      ];

      this.setState({ historical });
    } catch (error) {
      console.error('Historical error:', error);
    }
  };

  prices = async () => {
    const returnData = [];

    for (let i = 0; i < this.state.favorites.length; i++) {
      try {
        const priceData = await cc.priceFull(
          this.state.favorites[i],
          'USD'
        );

        returnData.push(priceData);
      } catch (error) {
        console.warn('Fetch price error:', error);
      }
    }

    return returnData;
  };

  historical = () => {
    const promises = [];

    for (let units = TIME_UNITS; units > 0; units--) {
      promises.push(
        cc.priceHistorical(
          this.state.currentFavorite,
          ['USD'],
          moment()
            .subtract({
              [this.state.timeInterval]: units
            })
            .toDate()
        )
      );
    }

    return Promise.all(promises);
  };

  addCoin = key => {
    const favorites = [...this.state.favorites];

    if (favorites.length < MAX_FAVORITES) {
      favorites.push(key);
      this.setState({ favorites });
    }
  };

  removeCoin = key => {
    const favorites = [...this.state.favorites];

    this.setState({
      favorites: _.pull(favorites, key)
    });
  };

  isInFavorites = key =>
    _.includes(this.state.favorites, key);

  confirmFavorites = () => {
    const currentFavorite = this.state.favorites[0];

    this.setState(
      {
        firstVisit: false,
        page: 'dashboard',
        currentFavorite,
        prices: null,
        historical: null
      },
      () => {
        this.fetchPrices();
        this.fetchHistorical();
      }
    );

    localStorage.setItem(
      'cryptoDash',
      JSON.stringify({
        favorites: this.state.favorites,
        currentFavorite
      })
    );
  };

  setCurrentFavorite = sym => {
    this.setState(
      {
        currentFavorite: sym,
        historical: null
      },
      this.fetchHistorical
    );

    localStorage.setItem(
      'cryptoDash',
      JSON.stringify({
        ...JSON.parse(localStorage.getItem('cryptoDash')),
        currentFavorite: sym
      })
    );
  };

  savedSettings() {
    const cryptoDashData = JSON.parse(
      localStorage.getItem('cryptoDash')
    );

    if (!cryptoDashData) {
      return {
        page: 'settings',
        firstVisit: true
      };
    }

    const { favorites, currentFavorite } = cryptoDashData;

    return {
      favorites,
      currentFavorite
    };
  }

  setPage = page => this.setState({ page });

  setFilteredCoins = filteredCoins =>
    this.setState({ filteredCoins });

  changeChartSelect = value => {
    this.setState(
      {
        timeInterval: value,
        historical: null
      },
      this.fetchHistorical
    );
  };

  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
